export function Footer() {
  return (
    <footer className="site-footer section-dark">
      <div className="footer-brand">
        <a href="/" aria-label="Informat Limited home">
          <img src="/assets/logo-color.svg" alt="informat" />
        </a>
        <p>Technology, quietly mastered.</p>
        <span>Owner-led technology consultancy.</span>
      </div>
      <nav aria-label="Footer navigation">
        <a href="/solutions">Solutions</a>
        <a href="/expertise">Expertise</a>
        <a href="/approach">Approach</a>
        <a href="/about">About</a>
        <a href="/contact">Contact</a>
        <a href="/privacy/">Privacy</a>
      </nav>
      <address>
        Informat Limited
        <br />
        Gorey, County Wexford, Ireland
      </address>
    </footer>
  )
}
